import { getApiUrl } from '@/shared/utils/helpers';
import Vue from 'vue';
export async function checkPreProcessing(info_set_id) {
    return await Vue.axios.get(`${getApiUrl('v4')}/enrichment_whatsapp/${info_set_id}/pre_processing_candidates`);
}
export async function listDecisorsWithContact(info_set_id, search, page) {
    return await Vue.axios.get(`${getApiUrl('v4')}/enrichment_whatsapp/${info_set_id}/list_decisors?page=${page}&search=${search}`);
}
export async function listPartners(info_set_id, search, page) {
    return await Vue.axios.get(`${getApiUrl('v4')}/enrichment_whatsapp/${info_set_id}/list_partners?page=${page}&search=${search}`);
}
export async function listEnrichmentDone(info_set_id, search, page) {
    return await Vue.axios.get(`${getApiUrl('v4')}/enrichment_whatsapp/${info_set_id}/list_enrichments_done?page=${page}&search=${search}`);
}
export async function checkTermsOfWhatsappEnrichment() {
    return await Vue.axios.get(`${getApiUrl('v4')}/enrichment_whatsapp/check_terms_of_use`);
}
export async function acceptTermsOfWhatsappEnrichment() {
    return await Vue.axios.post(`${getApiUrl('v4')}/enrichment_whatsapp/accept_terms_of_use`);
}
export async function listWhatsappEnrichmentResults(info_set_id) {
    return await Vue.axios.get(`${getApiUrl('v4')}/enrichment_whatsapp/${info_set_id}/list_results`);
}
export async function listWhatsappEnrichmentFound(info_set_id) {
    return await Vue.axios.get(`${getApiUrl('v4')}/enrichment_whatsapp/${info_set_id}/list_founded_whatsapps`, { responseType: 'blob' });
}
export async function requestWhatsappEnrichment(info_set_id, partners, decisors) {
    return await Vue.axios.post(`${getApiUrl('v4')}/enrichment_whatsapp/${info_set_id}/request_whatsapp_enrichment`, {
        partners,
        decisors,
    });
}
